export default "__VITE_ASSET__C8E$oqNV__"